"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useFocus = require("./useFocus");
Object.keys(_useFocus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFocus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useFocus[key];
    }
  });
});